import { Box, List, ListItem, Typography } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import { ThemedAsset, assetIds } from "nemuru-components";
import React, { useContext, useEffect } from "react";
import { ICON_TITLE_HEIGHT } from "../../../../../config/config";
import { ProcessContext } from "../../../../../contexts/ProcessContext";
import IconTitle from "../../../../shared/components/IconTitle";
import InfoPanel from "../../../../shared/components/InfoPanel";
import MainButton from "../../../../shared/components/MainButton";
import Text from "../../../../shared/components/Text";
import { ONBOARDING_PARTICIPANT_ROLES } from "../../../../shared/config";
import { infoDataBankReader } from "../config";
import { StyledToggleButtonGroup } from "../../../../shared/components/StyledToggleButtonGroup";

export default function IncomeTypeToggle({ onNext, disableIncomeToggle }) {
  const { palette } = useTheme();

  const {
    state: { participant },
    dispatch,
  } = useContext(ProcessContext);

  const [state, setState] = React.useState({
    selection: undefined,
    dialogState: false,
  });

  const { selection } = state;

  const setModuleKo = () => {
    dispatch({
      type: "SET_MODULE_KO",
    });
  };

  useEffect(() => {
    if (participant.role !== ONBOARDING_PARTICIPANT_ROLES.BORROWER) {
      setModuleKo();
    }
    setState((s) => ({ ...s, selection: "online" }));
  }, []);

  const handleSelection = (event, newSelection) => {
    if (newSelection !== null) {
      setState({ ...state, selection: newSelection });
    }
  };

  const onlineBank = () => {
    return (
      <>
        <Box className="appear-anim">
          <Typography
            style={{ color: palette.text.title }}
            variant="body2"
            align="center"
          >
            <strong>
              <Text tId="GET_INFO_BANK" />
            </strong>
          </Typography>
          <Box mt={3} />
          {!disableIncomeToggle && (
            <>
              <Typography color="primary" variant="body2" align="center">
                <strong>
                  <Text tId="PAPERLESS_EASY_AND_FAST" />
                </strong>
              </Typography>
              <Box mt={1} />

              <Box display="inline-flex" justifyContent="center">
                <List>
                  <ListItem style={{ alignItems: "start" }}>
                    <i
                      className="material-icons-outlined"
                      style={{
                        fontSize: 16,
                        color: palette.text.secondary,
                        verticalAlign: "text-top",
                        paddingRight: 10,
                      }}
                    >
                      vpn_key
                    </i>
                    <Typography variant="caption">
                      <Text tId="SELECT_BANK_AND_LOGIN" />
                    </Typography>
                  </ListItem>
                  <ListItem style={{ alignItems: "start" }}>
                    <i
                      className="material-icons-outlined"
                      style={{
                        fontSize: 16,
                        color: palette.text.secondary,
                        verticalAlign: "text-top",
                        paddingRight: 10,
                      }}
                    >
                      lock
                    </i>
                    <Typography variant="caption">
                      <Text tId="NO_PASSWORD_SAVED" />
                    </Typography>
                  </ListItem>
                </List>
              </Box>
            </>
          )}
        </Box>
      </>
    );
  };

  const traditionalPath = () => {
    return (
      <>
        <Box className="appear-anim">
          <Typography
            style={{ color: palette.text.title }}
            variant="body2"
            align="center"
          >
            <strong>
              <Text tId="TRADITIONAL_PATH" />
            </strong>
          </Typography>
          <Box mt={1} />

          {!disableIncomeToggle && (
            <Box display="inline-flex" justifyContent="center">
              <List>
                <ListItem style={{ alignItems: "start" }}>
                  <i
                    className="material-icons"
                    style={{
                      fontSize: 14,
                      verticalAlign: "text-top",
                      color: palette.text.secondary,
                      paddingRight: 10,
                    }}
                  >
                    hourglass_empty
                  </i>
                  <Typography variant="caption">
                    <Text tId="LONGER_PROCESS" />
                  </Typography>
                </ListItem>
                <ListItem style={{ alignItems: "start" }}>
                  <i
                    className="material-icons-outlined"
                    style={{
                      fontSize: 14,
                      verticalAlign: "text-top",
                      color: palette.text.secondary,
                      paddingRight: 10,
                    }}
                  >
                    insert_drive_file
                  </i>
                  <Typography variant="caption">
                    <Text tId="DOCUMENTATION_NEEDED" />
                  </Typography>
                </ListItem>
              </List>
            </Box>
          )}
        </Box>
      </>
    );
  };

  return selection ? (
    <>
      <Box>
        <IconTitle
          icon={
            <ThemedAsset
              id={assetIds.ICON_DATA_DUO}
              width={ICON_TITLE_HEIGHT}
              height={ICON_TITLE_HEIGHT}
              style={{ color: palette.secondary.main }}
            />
          }
          title={<Text tId="FINANCIAL_DATA" />}
          subtitle={<Text tId="CONNECT_WITH_YOUR_BANK" />}
        />
        <Box mt={5} />
        <StyledToggleButtonGroup
          selection={selection}
          handleSelection={handleSelection}
          options={[
            { value: "online", textId: "ONLINE_BANK" },
            { value: "tradicional", textId: "TRADITIONAL" },
          ]}
        />
        <Box mt={5} />
        {selection === "online" ? onlineBank() : traditionalPath()}
      </Box>
      <Box display="flex" justifyContent="center" style={{ width: "100%" }}>
        {selection === "online" ? (
          <MainButton onClick={() => onNext()}>
            <Text tId="CONTINUE" />
          </MainButton>
        ) : (
          <MainButton
            color="secondary"
            onClick={() => {
              dispatch({
                type: "SET_MODULE_KO",
              });
            }}
          >
            <Text tId="CONTINUE" />
          </MainButton>
        )}
        {selection === "online" && <InfoPanel infoData={infoDataBankReader} />}
      </Box>
    </>
  ) : (
    <></>
  );
}
